module.exports = __webpack_public_path__ + "static/media/Glossary.04dec0aa.svg";